import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useHistory } from 'react-router-dom';
import { searchFaqs, setSearchParameters } from 'actions/admin/faqs';
import { performSearch, mergeSearchParameters } from 'components/adminTable/AdminTableHelper';
import routes from 'routes';
import faqCategories from 'enums/faqCategories';

import AdminContentWrapper from '../../presentational/AdminContentWrapper';
import AdminPage from '../../presentational/AdminPage';
import AdminTable from 'components/adminTable/AdminTable';
import Box from '@material-ui/core/Box';
import Text from 'common/Text';
import Button from '@material-ui/core/Button';
import Loader from 'common/Loader';
import { Link } from 'react-router-dom';

const Faqs = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const history = useHistory();

    const searchResult = useSelector(state => state.admin.faqs.searchResult);
    const searchParametersFromState = useSelector(state => state.admin.faqs.searchParameters);

    const defaultParameters = {
        page: 0,
        pageSize: 20,
        sortByColumn: 'order',
        sortDirection: 'asc'
    };

    const columns = [
        {
            title: 'Id',
            id: 'id',
            render: faq => <Link to={routes.admin.updateFaq.replace(':faqId', faq.id)}>{faq.id}</Link>,
            align: 'right'
        },
        {
            title: 'Category',
            id: 'category',
            render: faq => faqCategories[faq.category].title
        },
        {
            title: 'Question',
            id: 'question',
            render: faq => <Text html={faq.question} />
        },
        {
            title: 'Sort order',
            id: 'order',
            render: faq => faq.order,
            align: 'right'
        }
    ];

    const search = parameters => {
        const searchParameters = mergeSearchParameters(parameters, location, searchParametersFromState, defaultParameters);
        performSearch(performSearchObject, searchParameters);
    };

    const performSearchObject = {
        searchParametersFromState,
        setSearchParametersToState: parameters => dispatch(setSearchParameters(parameters)),
        searchResult,
        search,
        apiCall: parameters => dispatch(searchFaqs(parameters)),
        location,
        history,
        isInitializedRef: useRef()
    };

    useEffect(() => {
        const searchParameters = mergeSearchParameters({}, location, searchParametersFromState, defaultParameters);
        performSearch(performSearchObject, searchParameters);
    }, []);

    const handleSort = sortingParameters => {
        search(sortingParameters);
    };

    const handlePageChange = newPage => {
        search({ page: newPage });
    };

    const handlePageChangeSize = newPageSize => {
        search({ page: 0, pageSize: newPageSize });
    };

    const actionPanel = (
        <Box>
            <Button
                type="button"
                variant="contained"
                color="primary"
                component={Link}
                to={routes.admin.createFaq}
            >
                Create new FAQ
            </Button>
        </Box>
    );

    return (
        <AdminPage title="FAQs" actionPanel={actionPanel}>
            <AdminContentWrapper type="listing">
                <Box>
                    {
                        searchResult.isLoading && <Loader />
                    }
                    {
                        searchResult.items && (
                            <AdminTable
                                isPaged
                                items={searchResult.items}
                                count={searchResult.count}
                                page={searchResult.page}
                                pageSize={searchResult.pageSize}
                                columns={columns}
                                sortByColumn={columns.find(c => c.id === searchParametersFromState.sortByColumn)}
                                sortDirection={searchParametersFromState.sortDirection}
                                onSort={handleSort}
                                onPageChange={handlePageChange}
                                onPageChangeSize={handlePageChangeSize}
                            />
                        )
                    }
                </Box>
            </AdminContentWrapper>
        </AdminPage>
    );
};

export default Faqs;
